import { useState, useEffect } from 'react';
/* import {parse, stringify} from 'flatted'; */

// import moment from 'moment';

import firebase, { db } from 'utils/firebase';

const useDbStudents = () => {
    const [StudentsLoading, setStudentsLoading] = useState(true);
    const [StudentsError, setStudentsError] = useState(false);
    const [Students, setStudents] = useState(null);

    
    useEffect(() => {

        const currentUserRef = db.collection('users').doc(firebase.auth().currentUser.uid);
        // const date30DaysAgo = parseInt(moment().subtract(30, 'days').format('YYYYMMDD'));
        const unsubscribe = db
            .collection('students')
            .where('owner_uid', '==', currentUserRef)
            // .where('date', '>=', date30DaysAgo)
            .onSnapshot(
                querySnapshot => {
                    let students = [];
                    querySnapshot.forEach(doc => {
						let student = doc.data();
						student.id = doc.id;
                        students.push(student);
                    });
                    setStudents(students);
                    setStudentsLoading(false);
					// console.info(`%cuseDbInvoices: ${querySnapshot.docChanges().length} document(s) read`, 'color: blue');
                },
                err => {
                    setStudentsError(err);
                    // console.error(err);
                }
            );
        return () => {
            unsubscribe();
            // console.info('%cuseDbInvoices: unsubscribed', 'color: blue');
        };
    }, []);

    return { StudentsLoading, StudentsError, Students };
};

export default useDbStudents;
